import apiClient from "../../services/apiClient";

export async function generateQRCodeAPI(data) {
  const response = await apiClient.post("/api/v1/paper-assignment/generate-qr/", data, {
    withAuth: true,
  });
  return response.data;
}

export async function fetchLevelsAPI() {
  const response = await apiClient.get("/api/v1/paper-assignment/levels/", {
    withAuth: true,
  });
  return response.data;
}

export async function fetchStudentsAPI(levelId = null) {
  let url = "/api/v1/paper-assignment/students/";
  if (levelId) {
    url += `?level_id=${levelId}`;
  }
  const response = await apiClient.get(url, {
    withAuth: true,
  });
  return response.data;
}

export async function fetchAssignmentsAPI(levelId = null) {
  let url = "/api/v1/paper-assignment/";
  if (levelId) {
    url += `?level_id=${levelId}`;
  }
  const response = await apiClient.get(url, {
    withAuth: true,
  });
  return response.data;
}

export async function uploadAssignmentAPI(formData) {
  const response = await apiClient.post("/api/v1/paper-assignment/upload/", formData, {
    withAuth: true,
    headers: {
      'Content-Type': 'multipart/form-data',
    }
  });
  return response.data;
}

export async function deleteAssignmentAPI(s3Key) {
  const response = await apiClient.delete(`/api/v1/paper-assignment/delete/${encodeURIComponent(s3Key)}/`, {
    withAuth: true,
  });
  return response.data;
}

export async function downloadAssignmentAPI(s3Key) {
  const response = await apiClient.get(`/api/v1/paper-assignment/download/${encodeURIComponent(s3Key)}/`, {
    withAuth: true,
  });
  return response.data;
}

export async function downloadQRPdfAPI(data) {
  const response = await apiClient.post("/api/v1/paper-assignment/download-qr-pdf/", data, {
    withAuth: true,
    responseType: 'blob', // Important for binary data
  });
  return response;
}

export async function createClassNoticeAPI(formData) {
  const response = await apiClient.post("/api/v1/paper-assignment/create-class-notice/", formData, {
    withAuth: true,
    headers: {
      'Content-Type': 'multipart/form-data',
    }
  });
  return response.data;
}

export async function fetchPaperAssignmentRecordsAPI(levelId = null, studentId = null) {
  let url = "/api/v1/paper-assignment/records/";
  const params = new URLSearchParams();
  
  if (levelId) {
    params.append('level_id', levelId);
  }
  if (studentId) {
    params.append('student_id', studentId);
  }
  
  if (params.toString()) {
    url += `?${params.toString()}`;
  }
  
  const response = await apiClient.get(url, {
    withAuth: true,
  });
  return response.data;
}

export async function deletePaperAssignmentRecordAPI(recordId) {
  const response = await apiClient.delete(`/api/v1/paper-assignment/records/${recordId}/`, {
    withAuth: true,
  });
  return response.data;
}

// 학생 제출물 다운로드 (교사용)
export async function downloadStudentSubmissionAPI(s3Key) {
  const response = await apiClient.get(`/api/v1/paper-assignment/download/${encodeURIComponent(s3Key)}/`, {
    withAuth: true,
  });
  return response.data;
}

// 학생 제출물 채점 및 첨삭 파일 업로드
export async function gradeStudentSubmissionAPI(formData) {
  const response = await apiClient.post("/api/v1/paper-assignment/grade-submission/", formData, {
    withAuth: true,
    headers: {
      'Content-Type': 'multipart/form-data',
    }
  });
  return response.data;
}

// 교사의 모든 학생들의 온라인 과제 목록 조회
export async function fetchTeacherStudentsOnlineAssignmentsAPI(levelId = null, studentId = null, isFinished = null) {
  let url = "/api/v1/assignment/list/teacher?page=1&limit=1000";

  if (levelId) {
    url += `&level_id=${levelId}`;
  }
  if (studentId) {
    url += `&student_id=${studentId}`;
  }
  if (isFinished !== null) {
    url += `&is_finished=${isFinished ? 'true' : 'false'}`;
  }

  const response = await apiClient.get(url, {
    withAuth: true,
  });
  return response.data.results || [];
}

// 해설지 PDF 다운로드
export async function retrieveCommentaryPDFAPI(assignmentId, studentId) {
  const response = await apiClient.get(
    `/api/v1/assignment/pdf/commentary?assignment_id=${assignmentId}&student_id=${studentId}`,
    { responseType: "blob" }
  );
  return response;
}